import { InjectProperty } from '@jack-henry/frontend-utils/di';
import { ProductFeatureType } from '@treasury/domain/company/product-features/types';
import { CompanyUserService } from '@treasury/domain/company/user';
import { CompanyUserProductEntitlements } from '@treasury/domain/company/user/entities/entitlements';
import { CompanyUserProductLimits } from '@treasury/domain/company/user/entities/limits';
import { TmBaseComponent } from '@treasury/presentation';
import { TmToastPosture, TmToastService } from '@treasury/presentation/services/toast';
import { html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import '../limits-and-entitlements/limits-and-entitlements.component';
import '../limits-and-entitlements/partials/account-list.component';

@customElement('tm-bo-limits-and-entitlements-reporting')
export class PositivePay extends TmBaseComponent {
    @InjectProperty()
    declare private readonly companyUserService: CompanyUserService;

    @InjectProperty()
    declare private readonly toastService: TmToastService;

    @property()
    declare private readonly companyId: number;

    @property()
    declare private readonly userId: number;

    @state()
    private loading = true;

    @state()
    private limits?: CompanyUserProductLimits;

    @state()
    private entitlements?: CompanyUserProductEntitlements;

    public render() {
        if (this.loading) {
            return html`<jha-progress></jha-progress> Loading Reporting Permissions...`;
        }
        return html`<div class="flex flex-col gap-10">${this.renderLimitsAndEntitlements()}</div>`;
    }

    protected async firstUpdated() {
        try {
            this.loading = true;
            this.limits = await this.companyUserService.getCompanyUserProductLimitsByType(
                this.userId,
                ProductFeatureType.InformationReporting,
                this.companyId
            );

            this.entitlements =
                await this.companyUserService.getCompanyUserProductEntitlementsByType(
                    this.userId,
                    ProductFeatureType.InformationReporting,
                    this.companyId
                );
        } catch {
            this.toastService.show('Error fetching reporting', TmToastPosture.Danger, true);
        } finally {
            this.loading = false;
        }
    }

    private renderLimitsAndEntitlements() {
        return html`<tm-company-user-limits-and-entitlements-common
            .companyId=${this.companyId}
            .userId=${this.userId}
            .limits=${this.limits}
            .entitlements=${this.entitlements}
        ></tm-company-user-limits-and-entitlements-common>`;
    }
}
